// extracted by mini-css-extract-plugin
module.exports = {"saveButton":"CharacterForm_saveButton__25xfO","form":"CharacterForm_form__3ygHE"};